export default "__VITE_ASSET__DroAyZ1k__"